module.exports = __webpack_public_path__ + "static/media/29ADMSPC40.44c61dc7.jpg";